export const OrdersEndpoints = {
  GET_ORDERS: '/api/admin/orders',
  GET_ORDER_DETAIL: (orderNumber: string) => `/api/admin/orders/${orderNumber}`,
  DISPATCH_ORDER: (orderNumber: string) => `/api/admin/orders/${orderNumber}/rerun`,
  GET_ORDER_CALLBACKS: (orderNumber: string) => `/api/admin/orders/${orderNumber}/callbacks`,
};
